export default __webpack_public_path__ + "static/media/hero-product-auth-left-uk-en.c3fec4a1.gif";